
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M409.804 259.688a216.071 216.071 0 00-67.063-59.695l16.052-58.282c38.459 16.967 71.909 43.147 97.594 75.762l-46.583 42.215zm-94.159-72.705c-26.75-10.608-56.055-16.039-86.661-14.966-7.094.249-14.093.846-20.987 1.76l-10.208-46.955c18.705-4.369 38.174-6.753 58.211-6.753 26.1 0 51.275 3.934 74.985 11.218l-15.34 55.696zM178.84 179.72c-40.5 11.237-76.012 34.009-103.028 64.405l-26.561-18.222c29.726-41.13 71.365-73.07 119.92-90.654l9.669 44.471zM57.557 267.766c-20.486 30.713-33.295 66.897-35.681 105.76H1c.272-44.449 11.942-86.183 32.188-122.478l24.369 16.718zm416.256-25.337c23.334 38.236 36.895 83.092 37.188 131.096h-59.903c-1.972-31.732-10.807-61.482-24.94-87.906l47.655-43.19zM306.861 400.564c0 28.368-22.998 51.365-51.365 51.365-23.13 0-41.355-16.286-50.768-36.314L120.91 284.29c-2.3-2.45-3.735-5.724-3.735-9.351 0-7.563 6.131-13.693 13.695-13.693 3.9 0 7.399 1.648 9.893 4.265l137.532 89.077c16.913 8.404 28.566 25.808 28.566 45.976z"}})])
          )
        }
      }
    